import { useRealtimeChatConnectionStatus } from "@/common/hooks/realtime/useRealtimeChatConnectionStatus";

import { ConnectionStatusIndicator } from "./ConnectionStatusIndicator";

/** Displays status of SignalR connection. */
export function RealtimeChatConnectionStatusIndicator() {
  const status = useRealtimeChatConnectionStatus();

  return <ConnectionStatusIndicator isConnected={status.connected} variant='alert' />;
}
